import * as React from "react";
import { TextBoxEditor } from "../../../../../../react-core/Html/TextBoxEditor";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../NewBusinessWizard/Components/SharedComponents";
import { ValidatorContents } from "../../../../Common/ValidatorHelper";
import { Name50 } from "../../../../../../react-core/Html/Validation/RegExPatterns";

interface IAccountNameProps extends IProcessComponentProps {
    readOnly: boolean;
}

interface IAccountNameState {}

export class AccountName extends ProcessComponent<IAccountNameProps, IAccountNameState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { data, readOnly } = this.props;
        const { AccountName } = data;
        return (
            <>
                {SectionHeader("Account details")}
                <TextBoxEditor
                    label={"Please provide an account name"}
                    required={"Please enter account name"}
                    cssWrapper="control-size-430"
                    value={data.IsJointAccount ? AccountName?.Full?.replace(/&amp;/g, "") : AccountName?.Full}
                    regex={{
                        errorMessage: ValidatorContents.Name50,
                        value: Name50,
                    }}
                    onChange={(v) => {
                        this.onAccountNameChange({ Full: v });
                    }}
                    disabled={readOnly}
                />
            </>
        );
    }

    private onAccountNameChange(changes) {
        const accountName = {};
        for (const key in changes) {
            accountName[key] = changes[key];
        }
        this.props.onChange({ AccountName: accountName });
    }
}
